import React from 'react';
import Panel from '../panels/Panel';
import DiceIcon from '../icons/DiceIcon';
import { CustomizeStep } from '@/components/avatar/constants.mjs';
import { useGeneratedUsername } from '@/lib/useGeneratedUsername';
import { useRouter } from 'next/router';

const UsernameSelector = ({setUsername, username, setState}) => {
    const { generatedUsername, isLoading, isError, fetchNewUsername } = useGeneratedUsername();
    const router = useRouter();
    const handleRandomize = (e) => {
        fetchNewUsername();
        setUsername(generatedUsername);
    }
    const displayedName = username.split(' \#') ? username.split(' \#')[0] : username

    return <Panel title={'Choose a username'}>
            <div className={'grid place-items-center grid-cols-5 gap-10 justify-center mt-2'}>
                <div className={'relative w-24 h-3 col-start-2 rounded-sm shadow bg-staff bg-opacity-75'} />
                <div className={'relative w-24 h-3 col-start-3 rounded-sm shadow bg-staff bg-opacity-25'} />
                <div className={'relative w-24 h-3 col-start-4 rounded-sm shadow bg-staff bg-opacity-25'} />
            </div> 
            <h1 className={'text-center font-gBlack text-3xl text-primary my-2'}>Create Your Triviatar</h1>
            <p className={'text-center leading-5 font-gReg text-xl text-primary mb-2 px-2'}>{"Before we begin, we need to know what to call you! We've generated a username for you. If you'd like to generate a new one, tap the dice."}</p>
            <div className={"text-center font-gBlack text-3xl text-primary my-2 w-full h-12 flex justify-center"}>
                <div className={'flex bg-white rounded-full w-3/4 h-full justify-end'}>
                    <div>
                        <p className={'text-primary text-xl font-gBold px-4 my-2 flex'}>{displayedName}</p>
                    </div>
                    <button className={'bg-primary rounded-full my-1 mr-1 pt-1'} onClick={handleRandomize}>
                        <DiceIcon width={'40px'} height='40px' className={'transform scale-125 px-2 my-2'}/>
                    </button>
                </div>
            </div>
            <div className={'grid grid-cols-6 justify-center place-items-center gap-4 my-2'}>
            <button 
						className={
							"flex bg-primary py-2 col-start-2 col-span-2 w-full rounded-md font-gBold uppercase px-4 justify-center text-xl"
						}
						onClick={() => router.push('/')}
						data-testid={`button-back`}
					>
						Back
					</button>
            <button 
						className={
							"flex bg-primary py-2 col-start-4 col-span-2 w-full rounded-md font-gBold uppercase px-4 justify-center text-xl"
						}
						onClick={() => setState(CustomizeStep.CUSTOMIZE)}
						data-testid={`button-save`}
					>
						Next
					</button>
            </div>
        </Panel>
};

export default UsernameSelector;